import type { GetStaticProps, InferGetStaticPropsType } from 'next'

import SecondaryPage from '~/components/secondaryPage/SecondaryPage'
import { readToken } from '~/lib/sanity.api'
import { getClient } from '~/lib/sanity.client'
import {
  getHostANode,
  getNavigation,
  HostANode, Navigation
} from '~/lib/sanity.queries'
import type { SharedPageProps } from '~/pages/_app'

import HostOne from '../components/secondaryPage/artwork/HostOne'
import HostThree from '../components/secondaryPage/artwork/HostThree'
import HostTwo from '../components/secondaryPage/artwork/HostTwo'

export const getStaticProps: GetStaticProps<
  SharedPageProps & {
    navigation: Navigation
    content: HostANode
  }
> = async ({ draftMode = false }) => {
  const client = getClient(draftMode ? { token: readToken } : undefined)
  const navigation = await getNavigation(client)
  const content = await getHostANode(client)

  return {
    props: {
      draftMode,
      token: draftMode ? readToken : '',
      navigation,
      content,
    },
  }
}

export default function HostPage(
  props: InferGetStaticPropsType<typeof getStaticProps>,
) {
  const navigation = props.navigation
  const content = props.content

  return (
    <SecondaryPage
      content={content}
      title="Host a Node"
      navigation={navigation}
      howItWorksArtwork={[
        <HostOne key="hiw-1" />,
        <HostTwo key="hiw-2" />,
        <HostThree key="hiw-3" />,
      ]}
    />
  )
}
